import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

import type {PeepRelatedLeadStatFragment_value_formattedValue as FormattedValue} from 'nutshell-graphql-types';

import {getStatColor} from './helpers';
import type {WidgetLeadStatus} from './leads-widget';

interface Props {
    status: WidgetLeadStatus;
    stat: FormattedValue;
}

export function LeadStat(props: Props) {
    const color = getStatColor(props.status);

    return (
        <Stack spacing={2}>
            <Body size='small' isBold={true}>
                {props.status}
            </Body>
            <Body size='large' color={color} isBold={true}>
                {props.stat.prefix}
                {props.stat.formatted}
                {props.stat.suffix}
            </Body>
        </Stack>
    );
}
